import { makeAutoObservable } from "mobx";
import { ApiResponse, IRootStore } from "..";
import Api from "../../services/api";
import { ApiConfig } from "../../services/api-config";
import _ from "lodash";
import { IAllergen } from ".";

export default class AllergenStore {
  allergens: Array<IAllergen> = [];
  editAllergen: IAllergen | null = null;
  private rootStore: IRootStore;

  constructor(rootStore: IRootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  fetchAllergens = () => {
    const url = ApiConfig.REST_URIS.allergen.fech;
    Api.get(url, (res: ApiResponse<IAllergen[]>) => {
      if (res?.isSuccess && res.data) {
        this.allergens = _.sortBy(res.data, "allergenName");
      }
    });
  };

  saveAllergen = (allergen: IAllergen, callback: Function) => {
    if (allergen.allergenId) {
      Api.put(
        ApiConfig.REST_URIS.allergen.update(allergen.allergenId),
        allergen,
        (res: ApiResponse<number>) => {
          callback && callback(res?.isSuccess && res.data);
        }
      );
    } else {
      Api.post(
        ApiConfig.REST_URIS.allergen.create,
        allergen,
        (res: ApiResponse<number>) => {
          callback && callback(res?.isSuccess && res.data);
        }
      );
    }
  };

  deleteAllergen = (allergenId: number, callback: Function) => {
    const url = ApiConfig.REST_URIS.allergen.delete(allergenId);

    Api.delete(url, (res: ApiResponse<number>) => {
      callback && callback(res?.isSuccess && res.data);
    });
  };

  setEditAllergen = (allergen: IAllergen | null) => {
    this.editAllergen = allergen;
  };
}
